/**
 * External Dependencies
 */
import "jquery";
import "bootstrap";
import "slick-carousel";
import navigation from "./navigation.js";
import slider from "./slider.js";

import testimonials from "./../../../blocks/testimonials/testimonials.js";
import logo_wall from "./../../../blocks/logo-wall/logo-wall.js";
import image_slider from "./../../../blocks/image-slider/image-slider.js";
import form from "./../../../blocks/form/form.js";
import history_slider from "./../../../blocks/history/history.js";
import video from "./../../../blocks/video/video.js";
import lp_logos from "./../../../blocks/lp-logos/lp-logos.js";

$('[data-toggle="tooltip"]').tooltip();

var lazyload = require("lazyload");
navigation();
slider();
testimonials();
image_slider();
form();
history_slider();
video();
logo_wall();
lp_logos();

$(document).ready(() => {
  // console.log('Hello world');
  $(function() {
    const images = document.querySelectorAll(".lazy");
    new lazyload(images);
  });

  $("[data-block-title]").each(function() {
    const title = $(this).data("block-title");
    const id = $(this).attr("id");
    if (title) {
      console.log(title);
      $(".js-teaser-nav").append('<a href="#' + id + '">' + title + "</a>");
    }
  });

  $('a[href^="#"]:not(.is--no-anchor)').on("click", function(e) {
    var hash = $(this).attr("href");

    if (hash !== "#") {
      var value = $(this).data("form-value");

      if (value) {
        jQuery("#nf-field-" + 845)
          .val(value)
          .trigger("change");
        jQuery("#nf-field-" + 859)
          .val(value)
          .trigger("change");
        jQuery("#nf-field-" + 873)
          .val(value)
          .trigger("change");
      }

      var target = $(hash);

      if (target.length) {
        e.preventDefault();

        const scrollTop = $(hash).offset().top;

        $("html, body").animate({ scrollTop });
        window.location.hash = hash;
      }
    }
  });

  var comp = new RegExp(location.host);

  $('a[target="_blank"]').each(function() {
    if (!comp.test($(this).attr("href"))) {
      $(this).attr("rel", "noopener");
    }
  });
});
